<template>
    <div class="body" id="joinUp">
        <div class="head">
            <div class="head-title">智慧食堂就餐大屏</div>
            <div class="canteen">{{canteensActive.name}}</div>
            <div class="nowTime">{{nowTime}}</div>
        </div>
        <div class="box">
            <div class="box-l ">
                <div class="box-lt box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="screen-title">当前备餐进度
                        <span class="title-tip">({{first.name}} {{first.startTime}} -- {{first.endTime}})</span>
                    </div>
                    <div class="box-use">
                        <div>
                            <div id="myEcharts5" class="usePie"></div>
                            <div>收银机就绪</div>
                        </div>
                        <div>
                            <div id="myEcharts6" class="usePie"></div>
                            <div>人员签到就绪</div>
                        </div>
                        <div>
                            <div id="myEcharts7" class="usePie"></div>
                            <div>菜单显示屏就绪</div>
                        </div>
                        <div>
                            <div id="myEcharts8" class="usePie"></div>
                            <div>菜品就绪</div>
                        </div>
                        <div>
                            <div id="myEcharts9" class="usePie"></div>
                            <div>餐具就绪</div>
                        </div>
                        <div>
                            <div id="myEcharts10" class="usePie"></div>
                            <div>名厨亮灶就绪</div>
                        </div>
                    </div>
                </div>
                <div class="box-lb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="echart">
                        <div class="screen-title">上周同期对比分析</div>
                        <div class="table-box divScroll">
                            <div class="table-title">
                                <div>指标</div>
                                <div>上周同期</div>
                                <div>今日</div>
                                <div>浮动%</div>
                            </div>
                            <div>
                                <div>就餐人次</div>
                                <div>{{screenDatas.firstT}}</div>
                                <div>{{screenDatas.lastT}}</div>
                                <div :class="screenDatas.lastT<screenDatas.firstT?'red':''">{{screenDatas.mealFloatPercent}}</div>
                            </div>
                            <div>
                                <div>售餐窗口数量</div>
                                <div>{{screenDatas.sevenDaysAgoPosCnt }}</div>
                                <div>{{screenDatas.todayPosCnt }}</div>
                                <div  :class="screenDatas.todayPosCnt<screenDatas.sevenDaysAgoPosCnt?'red':''">{{screenDatas.posFloatPercent }}</div>
                            </div>
                            <div>
                                <div>签到职工人数</div>
                                <div>{{screenDatas.signedWorkers_0 }}</div>
                                <div>{{screenDatas.signedWorkers_1 }}</div>
                                <div  :class="screenDatas.signedWorkers_1<screenDatas.signedWorkers_0?'red':''">{{screenDatas.signedWorkers_float }}</div>
                            </div>
                            <div>
                                <div>售餐峰值(人/分)</div>
                                <div>{{screenDatas.peak1 }}</div>
                                <div>{{screenDatas.peak2 }}</div>
                                <div  :class="screenDatas.peak2<screenDatas.peak1?'red':''">{{screenDatas.peakFloatPercent }}</div>
                            </div>
                            <div>
                                <div>掌银访问人数</div>
                                <div>{{screenDatas.login1 }}</div>
                                <div>{{screenDatas.login2 }}</div>
                                <div  :class="screenDatas.login2<screenDatas.login1?'red':''">{{screenDatas.loginFloatPercent }}</div>
                            </div>
                            <div>
                                <div>供应菜品数量</div>
                                <div>{{screenDatas.foodCount_0 }}</div>
                                <div>{{screenDatas.foodCount_1 }}</div>
                                <div  :class="screenDatas.foodCount_1<screenDatas.foodCount_0?'red':''">{{screenDatas.foodCount_float }}</div>
                            </div>
                            <div>
                                <div>就餐时长(分)</div>
                                <div>{{screenDatas.actualMealTime1  }}</div>
                                <div>{{screenDatas.actualMealTime2  }}</div>
                                <div  :class="screenDatas.actualMealTime2<screenDatas.actualMealTime1?'red':''">{{screenDatas.actualMealTimeFloat  }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="box-c">
                <div class="ct">
                    <div class="box-ctl">
                        <div class="box-ctt">
                            <div class="screen-title">就餐人数统计</div>
                            <div class="box-ct1">
                                <div>
                                    <div class="echartImg">
                                        <img src="../../assets/imgs/canteenScreen/img_03.png" alt="Background">
                                        <div class="echartBox">
                                            <div class="echartImg-title">今日就餐</div>
                                            <div class="echartImg-num">{{todayRepast.total}}人</div>
                                        </div>

                                    </div>
                                </div>
                                <div>
                                    <div id="myEcharts1" class="statics"></div>
                                </div>
                                <div>
                                    <div class="echartImg">
                                        <img src="../../assets/imgs/canteenScreen/img_05.png" alt="Background">
                                        <div class="echartBox">
                                            <div class="echartImg-title orange">本月就餐</div>
                                            <div class="echartImg-num">{{monthData.total}}人</div>
                                        </div>

                                    </div>
                                </div>
                                <div>
                                    <div id="myEcharts2" class="statics"></div>
                                </div>
                            </div>
                            <div class="box-ct2">
                                <div>
                                    <div class="ct2-name">今日早餐</div>
                                    <div class="ct2-num">{{todayRepast.a}}</div>
                                </div>
                                <div>
                                    <div class="ct2-name">今日午餐</div>
                                    <div class="ct2-num">{{todayRepast.b }}</div>
                                </div>
                                <div>
                                    <div class="ct2-name">今日晚餐</div>
                                    <div class="ct2-num">{{todayRepast.c }}</div>
                                </div>
                                <div>
                                    <div class="ct2-name">本月早餐</div>
                                    <div class="ct2-num">{{monthData.a }}</div>
                                </div>
                                <div>
                                    <div class="ct2-name">本月午餐</div>
                                    <div class="ct2-num">{{monthData.b }}</div>
                                </div>
                                <div>
                                    <div class="ct2-name">本月晚餐</div>
                                    <div class="ct2-num">{{monthData.c }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="box-ctb">
                            <div class="screen-title">近7日每天就餐人数/人次</div>
                            <div id="myEcharts3" class="ctb-statics"></div>
                        </div>
                    </div>
                    <div class="box-ctr box-img">
                        <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                        <div class="screen-title">今日餐谱</div>
                        <div class="menu">
                            <div class="menuName">
                                <div :class="menuIndex==index?'menuTab active':'menuTab' "
                                     v-for="(item,index) in menuPlanDetails" :key="index" @click="menuTabClick(index)">
                                    {{item.name}}
                                </div>
                            </div>
                            <div class="menuAll divScroll">
                                <div v-for="(item,index) in foods" :key="index" class="food">
                                    <img :src="item.images[0]" alt="">
                                    <p>{{item.name}}</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="cb">
                    <div class="cb-b box-img">
                        <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                        <div id="myEcharts4" class="statics"></div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "smartCanteenScreen",
        data() {
            return {
                nowTime: '',
                query: {
                    schoolId: '',
                    openid: 'abc',
                },
                screenDatas: {},
                todayRepast: {},
                monthData: {},
                first: {},
                menuPlanDetails: [],

                myCharts1: null,
                myCharts2: null,
                myCharts3: null,
                myCharts4: null,
                myCharts5: null,
                myCharts6: null,
                myCharts7: null,
                myCharts8: null,
                myCharts9: null,
                myCharts10: null,
                menuIndex: 0,
                foods: [],
                canteens: [],
                canteensActive: {},
            }
        },
        created() {
            this.query.schoolId = this.$route.query.schoolId
            window.onresize = () => {
                this.myCharts1.resize();
                this.myCharts2.resize();
                this.myCharts3.resize();
                this.myCharts4.resize();
                this.myCharts5.resize();
                this.myCharts6.resize();
                this.myCharts7.resize();
                this.myCharts8.resize();
                this.myCharts9.resize();
                this.myCharts10.resize();
            };
            this.nowTimes()
        },
        mounted() {
            this.funAll()
        },

        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = year + "-" + month + "-" + date + ' ' + hh + ":" + mm + ':' + ss

            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },

            funAll() {
                this.getDatas();
            },
            getDatas() {
                let url = "/zuhu1/api-dashboard/canteen/dashboard/v4"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data
                        this.screenDatas = datas
                        this.canteens = datas.canteens || []
                        this.canteensActive = this.canteens[0] || {}

                        let inThePastSevenDays = datas.inThePastSevenDays || []
                        let todayRepast = inThePastSevenDays[inThePastSevenDays.length - 1] || {}
                        todayRepast.total = (todayRepast.a || 0) + (todayRepast.b || 0) + (todayRepast.c || 0)
                        this.todayRepast = todayRepast

                        let monthData = datas.monthData
                        monthData.total = (monthData.a || 0) + (monthData.b || 0) + (monthData.c || 0)
                        this.monthData = monthData

                        this.first = datas.first || {}
                        this.menuPlanDetails = this.first.menuPlanDetails || []
                        this.menuIndex = 0
                        this.foods = this.menuPlanDetails[0].foods || []

                        this.statistics1(datas.dayMealPercent)
                        this.statistics2(datas.monthMealPercent)
                        this.statistics3(datas.inThePastSevenDays)
                        this.statistics4(datas.mealProgress)
                        this.statistics5(datas.cashRegisterPercent)

                        this.statistics6()
                        this.statistics7()
                        this.statistics8()
                        this.statistics9()
                        this.statistics10()

                    }
                })
            },
            statistics1(dayMealPercent) {
                let num = this.getPercentageNumber(dayMealPercent)
                this.myCharts1 = this.$echarts.init(document.getElementById('myEcharts1'))
                // 绘制图表
                this.myCharts1.setOption({
                    color: ['#4AACF3', '#0B1B35'],
                    title: {
                        text: dayMealPercent,
                        subtext: '今日就餐率',
                        left: 'center',
                        top: '35%',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {name: '今日就餐率', value: num},
                                {name: '其他', value: 100 - num},
                            ],
                        }
                    ]
                })
            },
            statistics2(monthMealPercent) {
                let num = this.getPercentageNumber(monthMealPercent)
                this.myCharts2 = this.$echarts.init(document.getElementById('myEcharts2'))
                // 绘制图表
                this.myCharts2.setOption({
                    color: ['#F5BD41', '#0B1B35'],
                    title: {
                        text: monthMealPercent,
                        subtext: '本月就餐率',
                        left: 'center',
                        top: '35%',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {name: '本月就餐率', value: num},
                                {name: '其他', value: 100 - num},
                            ],
                        }
                    ]
                })
            },
            statistics3(inThePastSevenDays) {
                let datas = inThePastSevenDays || []
                let dates = [], a = [], b = [], c = []
                datas.map(item => {
                    dates.push(item.date)
                    a.push(item.a)
                    b.push(item.b)
                    c.push(item.c)
                })
                this.myCharts3 = this.$echarts.init(document.getElementById('myEcharts3'))
                // 绘制图表
                this.myCharts3.setOption({
                    color: ['#01EC24', '#DFEB2E', '#3AFCE6'],
                    legend: {
                        data: ['早餐', '中餐', '晚餐'],
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '20%',
                        left: '5%',
                        right: '0%',
                        bottom: '15%'
                    },
                    xAxis: {
                        type: 'category',
                        data: dates,
                        axisLabel: {
                            color: '#b9bfd0',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }

                        },
                        axisTick: {
                            color: '#b9bfd0',
                            length: 5
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#A2A8B9',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }
                        },

                    },
                    series: [
                        {
                            name: '早餐',
                            data: a,
                            type: 'line',
                            areaStyle: {
                                color: '#01EC24',
                                opacity: 0.2,
                            },
                            smooth: true,
                        },
                        {
                            name: '中餐',
                            data: b,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: '#DFEB2E',
                                opacity: 0.2,
                            },
                        },
                        {
                            name: '晚餐',
                            data: c,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: '#3AFCE6',
                                opacity: 0.2,
                            },
                        }
                    ]
                })
            },

            statistics4(mealProgress) {
                let datas = mealProgress || {}
                let x = Object.keys(datas);
                let y = Object.values(datas);
                let y1=[]
                y.map(item=>{
                    y1.push(0)
                })

                this.myCharts4 = this.$echarts.init(document.getElementById('myEcharts4'))
                // 绘制图表
                this.myCharts4.setOption({
                    color: ['#DDD02B', '#3AE4DB'],
                    legend: {
                        data: ['售餐人次','当前排队人数'],
                        y: '8%',
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        top: '5%',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '20%',
                        left: '8%',
                        right: '5%',
                        bottom: '15%'
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLabel: {
                            color: '#b9bfd0',
                            fontSize: 14
                        },

                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#A2A8B9',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }
                        },

                    },
                    series: [
                        {
                            name: '售餐人次',
                            data: y,
                            type: 'bar',
                        },
                        {
                            name: '当前排队人数',
                            data: y1,
                            type: 'bar',
                        },
                    ]
                })
            },

            statistics5(cashRegisterPercent) {
                let datas = [
                    {value: cashRegisterPercent},
                    {value: (100 - cashRegisterPercent) || 0}
                ]
                this.myCharts5 = this.$echarts.init(document.getElementById('myEcharts5'))
                // 绘制图表
                this.myCharts5.setOption({
                    color: ['#1684FC', '#F61801'],
                    title: {
                        text: cashRegisterPercent + '%',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: datas,
                        }
                    ]
                })
            },

            getPercentageNumber(percentageStr) {
                const number = parseFloat(percentageStr.replace('%', '')); // 移除 % 并转为浮点数
                return number;
            },
            menuTabClick(index) {
                this.menuIndex = index
                this.foods = this.menuPlanDetails[index].foods
            },
            statistics6() {
                this.myCharts6 = this.$echarts.init(document.getElementById('myEcharts6'))
                // 绘制图表
                this.myCharts6.setOption({
                    color: ['#32AABE', '#0B1B34'],
                    title: {
                        text:  '0%',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics7() {
                this.myCharts7 = this.$echarts.init(document.getElementById('myEcharts7'))
                // 绘制图表
                this.myCharts7.setOption({
                    color: ['#CF8294', '#0B1B34'],
                    title: {
                        text:  '0%',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics8() {
                this.myCharts8 = this.$echarts.init(document.getElementById('myEcharts8'))
                // 绘制图表
                this.myCharts8.setOption({
                    color: ['#52AC93', '#0B1B34'],
                    title: {
                        text:  '0%',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics9() {
                this.myCharts9 = this.$echarts.init(document.getElementById('myEcharts9'))
                // 绘制图表
                this.myCharts9.setOption({
                    color: ['#786851', '#0B1B34'],
                    title: {
                        text:  '0%',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics10() {
                this.myCharts10 = this.$echarts.init(document.getElementById('myEcharts10'))
                // 绘制图表
                this.myCharts10.setOption({
                    color: ['#B3AC68', '#0B1B34'],
                    title: {
                        text:  '0%',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },


            // getPieChart11() {
            //     let url = "/zuhu1/api-dashboard/canteen/dashboard2/v4"
            //     let query = {
            //         schoolId: this.$route.query.schoolId,
            //         openid: 'abc',
            //         canteenId: this.screenDatas.canteens[0].canteenId
            //     }
            //     this.$api.post(url, query, response => {
            //         if (response.data.result == "success") {
            //         }
            //     })
            // },

        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        /*height: 1080px;*/
        height: 100%;
        background: rgb(3, 17, 51);
        overflow: hidden;
        background: url("../../assets/imgs/smartLinkBigScreen/bg.jpg") no-repeat center 0;
    }

    .head {
        height: 120px;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 38px;
        position: relative;
        background: url("../../assets/imgs/smartLinkBigScreen/topbg.png") no-repeat center 0;
        box-sizing: border-box;
    }
    .head-title{
        background: -webkit-linear-gradient(#4AF3F3, #179DF5);
        -webkit-background-clip: text;
        color: transparent;
        font-weight: bold;
    }


    .box {
        display: flex;
        /*height: 960px;*/
        height: calc(100% - 100px);
        margin-top: -20px;
    }

    .box > div {
        padding: 10px 0 0;
    }

    .box > div > div {
        width: 90%;
        margin: 0 auto 20px;
    }

    .box-l {
        width: 25%;
    }

    .box-c {
        flex: 1;
    }


    .screen-title {
        color: white !important;
        font-weight: bold;
        font-size: 20px;
        padding: 20px 30px 10px;
        z-index: 10;
        position: relative;
    }


    .box-lt {
        height: 50%;
        min-height: 180px;
        position: relative;
    }

    .box-img img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
    }

    .box-lb {
        height: 45%;
        position: relative;
    }

    .table-box {
        display: flex;
        flex-direction: column;
        color: #ffffff;
        padding: 0 10px 0 0;
        height: calc(100% - 68px);
        overflow-y: auto;
    }

    .table-box > div {
        display: flex;
        font-size: 14px;
    }

    .table-box > div > div {
        /*width: 25%;*/
        flex: 1;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }

    .table-title {
        background: #135065;
    }


    .table-box > div {
        display: flex;
        color: rgb(229, 238, 227);
        justify-content: space-between;
    }

    .table-box > div:nth-child(odd) {
        background: #12364E;
    }

    .table-box > div > p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .statics {
        width: 100%;
        /*height: 150px*/
        height: 100%;
        position: relative;
    }

    .ctb-statics {
        width: 100%;
        height: calc(100% - 56px);
    }


    .box-ctt {
        height: 50%;
    }

    .box-ctb {
        height: 50%;
    }


    .box-ct1 {
        display: flex;
        justify-content: space-between;
        height: calc(100% - 150px);
    }

    .box-ct1 > div {
        flex: 1;
        position: relative;
    }

    .box-ct2 {
        display: flex;
    }

    .box-ct2 > div {
        flex: 1;
        border: 1px solid #1D5A98;
        text-align: center;
    }

    .ct2-name {
        color: white;
        padding: 10px 0;
    }

    .ct2-num {
        color: #40FFED;
        font-size: 24px;
        padding: 0 0 10px 0;
    }

    .ct {
        width: 95% !important;
        height: 68%;
        display: flex;
        justify-content: space-between;
    }

    .cb {
        height: 30%;
        width: 97% !important;
    }

    .box-ctl {
        width: 63%;
        padding: 10px 0 0 0 !important;
    }

    .box-ctr {
        width: 33%;
        position: relative;
    }

    .echartImg {
        height: 100%;
        width: 100%;
        text-align: center;
    }

    .echartImg img {
        position: absolute;
        height: 92%;
        top: 4%;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;
    }

    .echartBox {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        height: 100%;
        width: 100%;
    }

    .cb-b {
        height: calc(100% - 20px);
        width: 100%;
        position: relative;
    }

    .echartImg-title {
        color: #26AADD;
        font-size: 14px;
        height: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .orange {
        color: #F3BF3F !important;
    }

    .echartImg-num {
        color: white;
        height: 30%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
    }

    .box-use {
        height: calc(100% - 66px);
    }

    .box-use > div {
        display: inline-block;
        height: 48%;
        width: 33%;
        color: white;
        text-align: center;
    }

    .usePie {
        width: 100%;
        height: calc(100% - 30px);
    }

    .title-tip {
        color: #999;
        font-size: 14px;
    }

    .menu {
        position: relative;
        z-index: 10;
    }

    .menuName {
        text-align: center;
        padding: 0 0 5px 0;
    }

    .menuTab {
        display: inline-block;
        color: white;
        background: #00A9FE;
        padding: 5px 20px;
        margin: 0 10px;
    }

    .active {
        background: #FEA21D !important;
    }

    .menu {
        width: 100%;
        height: calc(100% - 63px);
    }

    .menuAll {
        height: calc(100% - 55px);
        display: flex;
        flex-wrap: wrap;
        overflow-y: auto;
        padding: 10px 10px 0;
    }

    .food {
        width: 32%;
        margin: 4px 0.5%;
        color: white;
        text-align: center;
    }

    .food img {
        position: relative !important;
        width: 100%;
        height: 120px;
    }

    .food p {
        background: #265080;
        padding: 4px 0;
    }

    .divScroll::-webkit-scrollbar {
        width: 4px;
    }

    .divScroll::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: rgba(120, 229, 250, 1);
    }

    .divScroll::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(120, 229, 250, 0.6);
    }

    .canteen {
        color: #69E7EE;
        position: absolute;
        left: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }
    .nowTime{
        color: #69E7EE;
        position: absolute;
        right: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }

    .echart{
        position: relative;
        z-index: 10;
        color: white !important;
        height: 100%;
    }
    .red{
        color: red;
    }
</style>

